import React from 'react';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import Banner from 'components/Content/Banner';
import contentConsts from 'constants/content';
import Empty from 'constants/empty';

const { BANNER_TYPES, CONTEXTS } = contentConsts;

class PersistentBanner extends BaseClass {
    ref = React.createRef();

    constructor(props) {
        super(props);

        this.urlObserver = null;
        this.debounceTimer = null;

        this.state = {
            currentPath: null,
            mergedProps: null
        };
    }

    fireImpressionEvent = () => {
        const { triggerImpression } = this.props;

        if (triggerImpression) {
            triggerImpression();
        }
    };

    delegateClick = () => {
        if (this.props.triggerClick) {
            const { data } = this.props;
            const firstBanner = data[0];

            this.props.triggerClick(firstBanner);
        }
    };

    delegateImpressionEvent = () => {
        this.fireImpressionEvent();
    };

    render() {
        const content = (this.props.data && Array.isArray(this.props.data) && this.props.data[0]) || Empty.Object;
        const personalization = content?.personalization || Empty.Object;

        return Object.keys(content).length ? (
            <div ref={this.ref}>
                <Banner
                    {...content}
                    bannerType={BANNER_TYPES.PERSISTENT}
                    marginTop={[0, 0]}
                    marginBottom={[0, 0]}
                    personalization={personalization}
                    context={CONTEXTS.PERSISTENT_BANNER}
                    useMediaHeight={this.props.useMediaHeight}
                    fireClickTrackingEvent={false}
                    delegateClick={this.delegateClick}
                    delegateImpressionEvent={this.delegateImpressionEvent}
                />
            </div>
        ) : null;
    }
}

export default wrapComponent(PersistentBanner, 'PersistentBanner', true);
